import {ConnectedPosition} from '@angular/cdk/overlay';
import {Component, HostBinding, Input} from '@angular/core';
import {ContextMenuAction} from './context-menu-action';
import {OVERLAY_POSITIONS} from '../overlay/overlay.constants';

@Component({
  selector: 'app-context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.scss'],
  standalone: false
})
export class ContextMenuComponent {
  @Input() actions: ContextMenuAction[];
  @Input() disabled = false;
  /** Overlay positions; below-first, flipping above. The directive stands the menu off the trigger. */
  @Input() positions: ConnectedPosition[] = OVERLAY_POSITIONS;

  open = false;

  @HostBinding('class.disabled') get dc() {
    return this.disabled;
  }

  /** Disabled is a plain guard now; the tippy version had to suppress itself with `trigger: manual`. */
  toggle() {
    if (!this.disabled) {
      this.open = !this.open;
    }
  }

  handleAction(action: ContextMenuAction, event: Event) {
    if (action.link && !action.isEnabled) {
      event.preventDefault();
    }
    if (action.callback) {
      if (action.isEnabled) {
        action.callback();
      }
    }
    // Closes this menu only. `hideAll()` used to close every tippy on the page, including the
    // lock-control dropdown and the table's own popups if one happened to be open.
    this.open = false;
  }
}
